import * as React from "react";
const SvgBlueDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 8, viewBox: "0 0 9 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 4.5, cy: 4, r: 3, fill: "#095BFF" }));
export default SvgBlueDot;
